import { Button, ButtonProps } from '@mui/material';
import { FilterList as FilterListIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type SttButtonFilterProps = {
    onClick: () => void;
    caption?: string;
} & ButtonProps;

/**
 * Filter button
 */
export function SttButtonFilter({
    onClick,
    caption,
    ...rest
}: SttButtonFilterProps) {
    const { t } = useTranslation();

    return (
        <Button
            variant="outlined"
            onClick={onClick}
            startIcon={<FilterListIcon />}
            {...rest}
        >
            {caption || t('Filter')}
        </Button>
    );
}
